<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

  <div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <img src="../../../../assets/images/solapur_logo.png" width="80px;" height="70px;" >
      <a class="logo" href="#" (click)="navigateHome()">Verification<span></span></a>
      
    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select> -->
  </div>
  <!-- <div class="header-container" >
    <select (change)="onChange($event.target.value)"name="languagectrl" id="languagectrl" class="form-control"
      placeholder="Please Select Language" formControlName="languagectrl">
      <option _ngcontent-jco-c75="" value="" disabled="" selected=""> Please Select Language
      </option>
      <option _ngcontent-jco-c75="" value="English" class="ng-star-inserted">English</option>
      <option _ngcontent-jco-c75="" value="Gujarati" class="ng-star-inserted"> Gujarati</option>
    </select>
  </div> -->
  
    
  <div class="header-container">
    <nb-actions size="small">
      <nb-action class="user-action"  *nbIsGranted="['view', 'current-user']">
        <nb-user [nbContextMenu]="userMenu"
                 [onlyPicture]="userPictureOnly"
                 [name]="user?.firstName"
                 [picture]="user?.picture | ngxAuthToken | async">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
  